import { useApiClient } from "@/hooks/useApiClient";
import useSWR from "swr";

export interface ClientMonthlyBudgetStatusListAPIResponse {
  planPrice: number;
  carryoverMoney: number;
  priorYearAdjustment: number;
  budget: number;
  remainingBudget: number;
  id: number | null;
  totalConsumeCredit: number | null;
  tax: number | null;
  billingDate: string;
}

export const useClientMonthlyBudgetStatusList =
  (): ClientMonthlyBudgetStatusListAPIResponse[] => {
    const { apiClient } = useApiClient();

    const fetcher = async (
      url: string
    ): Promise<ClientMonthlyBudgetStatusListAPIResponse[]> => {
      return (
        await apiClient.get<ClientMonthlyBudgetStatusListAPIResponse[]>(url)
      ).data;
    };
    const { data: monthlyBudgetStatus } = useSWR(
      "/credit/client-monthly-budget-status",
      fetcher,
      {
        revalidateOnFocus: false,
      }
    );

    return monthlyBudgetStatus ?? [];
  };
